import {
  toastTypes,
  errorMessages,
  successMessages,
  aiReplyReduxConstants,
} from "../../constants";
import { aiReplyServices } from "../../services";
import { customToast } from "../../../../shared";
import { withSpinner, success } from "../../../../redux/actions/utilities";

const {
  GET_BRAND_SOCIAL_LINKS,
  RESET_BRAND_SOCIAL_LINKS,
  UPDATE_BRAND_SOCIAL_LINKS,
  GET_ALL_BRANDS_FOR_AI_REPLY,
} = aiReplyReduxConstants;

// Fetching AI Reply brand paginated data
const getAllBrandsForAiReply = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_ALL_BRANDS_FOR_AI_REPLY, () =>
      aiReplyServices
        .getAllBrandsForAiReply(body)
        .then(
          (response) => {
            dispatch(success(response, GET_ALL_BRANDS_FOR_AI_REPLY));
          },
          (error) => {
            const errorMessage =
              error[0] || errorMessages.FAILED_TO_FETCH_BRANDS_FOR_AI_REPLY;
            customToast(errorMessage, toastTypes.ERROR);
          }
        )
    );
  };
};

const updateBrandSocialLinks = (body) => {
  return (dispatch) => {
    return withSpinner(dispatch, UPDATE_BRAND_SOCIAL_LINKS, () =>
      aiReplyServices
        .updateBrandSocialLinks(body)
        .then(
          (_response) => {
            customToast(successMessages.UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            const errorMessage =
              error[0] || errorMessages.FAILED_TO_UPDATE_BRAND_SOCIAL_LINKS;
            customToast(errorMessage, toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

const getBrandSocialLinks = (brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_BRAND_SOCIAL_LINKS, () =>
      aiReplyServices
        .getBrandSocialLinks(brandId)
        .then(
          (response) => {
            dispatch(success(response, GET_BRAND_SOCIAL_LINKS));
          },
          (error) => {
            const errorMessage =
              error[0] || errorMessages.FAILED_TO_FETCH_BRAND_SOCIAL_LINKS;
            customToast(errorMessage, toastTypes.ERROR);
          }
        )
    );
  };
};

const resetBrandSocialLinks = () => (dispatch) => {
  dispatch(success({}, RESET_BRAND_SOCIAL_LINKS));
};

export const aiReplyActions = {
  getBrandSocialLinks,
  resetBrandSocialLinks,
  getAllBrandsForAiReply,
  updateBrandSocialLinks,
};
